<template>
  <div>
    <v-dialog
      v-model="EndCallDialog"
      width="500"
      persistent
    >
      <v-card style="height: 350px !important;">
        <v-card-text>
          <v-layout column wrap justify-center align-center style="height: 265px !important;">
            <v-avatar
              :size="100"
            >
            <img :src="infor_friend.picture" class="img-w-h" v-if="infor_friend.picture">
            <img src="/static/img/default_profile/bot-white.png" class="img-w-h" v-else>
            </v-avatar>
            <h3 class="text-overflow mt-3 text-transform">{{$t('LeftSide.chat.call.end')}}</h3>
            <h2 class="text-overflow mt-3">{{infor_friend.nickname}}</h2>
            <!-- <h4 class="text-overflow mt-3">เวลาทั้งหมด {{time_count}}</h4> -->
          </v-layout>
          <v-layout row wrap justify-center align-center>
            <v-btn class="border-radius text-transform" dark color="primary" @click="closedialog()">{{$t('AnswerQuestion.ok')}}</v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { Encode } from '@/services'
export default {
  props: {
    EndCallDialog: Boolean,
    infor_friend: {},
    time_count: Number
  },
  data () {
    return {
    }
  },
  created () {
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  },
  watch: {
    EndCallDialog () {
      if (this.EndCallDialog) {
        // console.log(this.infor_friend)
      }
    }
  },
  methods: {
    closedialog () {
      this.$emit('closeEndCallDialog', false)
    },
  }
}
</script>
<style media="screen" scroped>
.text-transform {
  text-transform: none;
}
.img-w-h {
  object-fit: cover;
  object-position: 50% 40%;
  height: 150px;
  width: 100%;
}
.text-overflow {
  max-width: 400px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}
.border-radius {
  border-radius: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/agora_call/end_call_v2.vue